import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Container, Content, Icon, Text, Visibility } from '../styled';

class Banner extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      height: 0
    });

    _defineProperty(this, "getHeight", () => {
      if (this.containerRef) {
        this.setState({
          height: this.containerRef.clientHeight
        });
      }
    });

    _defineProperty(this, "innerRef", ref => {
      this.containerRef = ref;

      if (this.props.innerRef) {
        this.props.innerRef(ref);
      }

      this.getHeight();
    });

    _defineProperty(this, "getA11yProps", appearance => {
      const {
        isOpen
      } = this.props;
      const defaultProps = {
        'aria-hidden': !isOpen,
        role: 'alert'
      };

      if (appearance === 'announcement') {
        return { ...defaultProps,
          'aria-label': 'announcement',
          tabIndex: 0,
          role: 'region'
        };
      }

      return defaultProps;
    });
  }

  render() {
    const {
      appearance,
      children,
      icon,
      isOpen,
      testId
    } = this.props;
    const allyProps = this.getA11yProps(appearance);
    return /*#__PURE__*/React.createElement(Visibility, {
      bannerHeight: this.state.height,
      isOpen: isOpen
    }, /*#__PURE__*/React.createElement(Container, _extends({
      innerRef: this.innerRef,
      appearance: appearance,
      "data-testid": testId
    }, allyProps), /*#__PURE__*/React.createElement(Content, {
      appearance: appearance
    }, /*#__PURE__*/React.createElement(Icon, null, icon), /*#__PURE__*/React.createElement(Text, {
      appearance: appearance
    }, children))));
  }

}

_defineProperty(Banner, "defaultProps", {
  appearance: 'warning',
  isOpen: false
});

export default Banner;